import { useMemo } from 'react';
import { useMyPermissionsQuery } from '@/store/api/authApi';

interface PermissionCheck {
  action: string;
  entityTypeId?: number;
}

export function usePermission() {
  const hasToken = Boolean(localStorage.getItem('cv2:access'));
  const { data: perms = [], isLoading } = useMyPermissionsQuery(undefined, { skip: !hasToken });

  return useMemo(() => ({
    can(check: PermissionCheck): boolean {
      return perms.some((permission) => {
        if (permission.action !== check.action) {
          return false;
        }
        if (
          permission.entityTypeId !== null
          && check.entityTypeId !== undefined
          && permission.entityTypeId !== check.entityTypeId
        ) {
          return false;
        }
        return true;
      });
    },
    actions: new Set(perms.map((permission) => permission.action)),
    isLoading,
  }), [isLoading, perms]);
}
